module.exports = __webpack_public_path__ + "static/media/leadership-min.66594ec6.jpg";